package org.example.project

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    // Initialize Firebase
    val options = FirebaseConfig(
        apiKey = "AIzaSyBrAi2Gsa4wMxilbSPW4AC8YmMvB09xCkA",
        authDomain = "plushmorph.firebaseapp.com",
        projectId = "plushmorph",
        storageBucket = "plushmorph.firebasestorage.app",
        messagingSenderId = "410313637844",
        appId = "1:410313637844:web:21a188d2484aab39206041",
        measurementId = "G-36NRS6ZDQP"
    )
    
    try {
        FirebaseManager.initialize(options)
        println("Firebase initialize success")
    } catch (e: Exception) {
        println("Failed to initialize Firebase: ${e.message}")
    }

    ComposeViewport {
        App()
    }
}